import { Link } from "react-router-dom";
import React from "react";

export default function Banner(props) {
  return (
    <section
      className="breadcrumb-area d-flex align-items-center"
      style={{ backgroundColor: "#010f2e" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-12 col-lg-12">
            <div className="breadcrumb-wrap text-left">
              <div className="breadcrumb-title">
                <div className="container-fluid d-flex align-items-center justify-content-between">
                  <div className="left-content">
                    {/* Create a new div for left content */}
                    <h2 className="mx-4 mt-5 mb-3 text-light fw-bolder fs-1">
                      {props.title}
                    </h2>
                  </div>
                  {sessionStorage.getItem("name") &&
                  <div className="right-content">
                    <h5 className="mx-5 mt-5 mb-3 text-light text-right fw-bolder">
                      Hi, {sessionStorage.getItem("name")}
                    </h5>
                  </div>}
                </div>
                <div className="breadcrumb-wrap">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mx-5">
                      <li className="breadcrumb-item">
                        <Link
                          to="/"
                          className="fw-bold fs-6 text-decoration-none"
                        >
                          {" "}
                          Home{" "}
                        </Link>
                      </li>
                      {props.previousPage && (
                        <li
                          className="breadcrumb-item active fw-bold fs-6"
                          aria-current="page"
                        >
                          <Link
                            to={props.link}
                            className="fw-bold fs-6 text-decoration-none"
                          >
                            {props.previousPage}
                          </Link>
                        </li>
                      )}
                      <li
                        className="breadcrumb-item active fw-bold fs-6"
                        aria-current="page"
                      >
                        {props.currentpage}
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
